"use client";
import { styled } from "@mui/material/styles";
import InnerTypography from "@mui/material/Typography";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
export const Typography = styled(InnerTypography, {
    shouldForwardProp: (prop) => !["legiblelinewidth", "responsiveContainer"].includes(prop.toString()),
})(({ theme, legiblelinewidth }) => {
    useCheckThemeContext("Typography");
    const dt = theme.pixel;
    // Activate commented code below when Player typography is responsive
    // const containerName = responsiveContainer !== true ? responsiveContainer : '';
    // const responsiveType = responsiveContainer ? `@container ${containerName}` : '@media';
    // const ptXs = dt.responsive.xSmall.player.typography;
    // const fallbackHeading = dt.fontFamilies.heading.fallback;
    return Object.assign({}, (legiblelinewidth && {
        maxWidth: dt.typography.legibleLineLength,
    }));
});
